export default "__VITE_ASSET__vrMJKVJS__"